import { render, staticRenderFns } from "./ACallNotificationsCard.vue?vue&type=template&id=d909576c"
import script from "./ACallNotificationsCard.vue?vue&type=script&lang=js"
export * from "./ACallNotificationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports